import { t } from "i18next";

import Shimmer from "@/components/Shimmer";
import ComponentError from "@/components/ComponentError";
import { useGetPrivacyCentreUrl } from "@/requests/hooks/comply";

const LivePreview = () => {
  const {
    data: privacyCentreUrlData,
    isLoading: isGetPrivacyCentreUrlLoading,
    isError: isGetPrivacyCentreUrlError,
  } = useGetPrivacyCentreUrl();

  const renderLoading = () => (
    <Shimmer width="100%" height="500px" rounded="sm" />
  );

  const renderTitleBar = () => {
    return (
      <div className="flex h-[15px] w-full items-center bg-[#DFE3E9]">
        <div className="ml-[6px] flex flex-row items-center gap-x-[5px]">
          <div className="h-[4px] w-[4px] rounded-full bg-[#FF0000]"></div>
          <div className="h-[4px] w-[4px] rounded-full bg-[#FFD600]"></div>
          <div className="h-[4px] w-[4px] rounded-full bg-[#39B54A]"></div>
        </div>
      </div>
    );
  };

  const renderIFrame = (): React.ReactElement => (
    <div className="mt-30 drop-shadow-xl">
      {renderTitleBar()}
      <div className="h-[500px] w-full overflow-hidden">
        <iframe
          className="h-full w-full origin-top-left transform-none sm:max-w-full"
          src={privacyCentreUrlData?.url}></iframe>
      </div>
    </div>
  );

  if (isGetPrivacyCentreUrlLoading) return renderLoading();

  if (isGetPrivacyCentreUrlError || !privacyCentreUrlData?.url)
    return <ComponentError message={t("comply.privacyCenter.preview.error")} />;

  return renderIFrame();
};

export default LivePreview;
